import { create } from 'zustand';
import type { AiStatus, Consent, Member } from '@hew3/shared';
import { api, setToken } from '../lib/api.ts';

interface MeResponse {
  member: Member;
  consents: Consent[];
  ai: AiStatus;
}

interface AuthState {
  /** 是否已完成初始化探测（避免首屏闪一下登录页） */
  ready: boolean;
  member: Member | null;
  consents: Consent[];
  ai: AiStatus | null;
  bootstrap: () => Promise<void>;
  setSession: (token: string) => Promise<void>;
  refreshMe: () => Promise<void>;
  setConsents: (consents: Consent[]) => void;
  logout: () => Promise<void>;
}

export const useAuth = create<AuthState>((set, get) => ({
  ready: false,
  member: null,
  consents: [],
  ai: null,

  /** 启动时探测：有 token 就换取身份，没有就直接进入未登录态。 */
  bootstrap: async () => {
    try {
      const me = await api.get<MeResponse>('/api/auth/me');
      set({ member: me.member, consents: me.consents, ai: me.ai, ready: true });
    } catch {
      set({ member: null, consents: [], ai: null, ready: true });
    }
  },

  setSession: async (token: string) => {
    setToken(token);
    await get().refreshMe();
  },

  refreshMe: async () => {
    try {
      const me = await api.get<MeResponse>('/api/auth/me');
      set({ member: me.member, consents: me.consents, ai: me.ai, ready: true });
    } catch {
      setToken(null);
      set({ member: null, consents: [], ai: null, ready: true });
    }
  },

  setConsents: (consents) => set({ consents }),

  logout: async () => {
    try {
      await api.post('/api/auth/logout');
    } catch {
      // 即便服务端吊销失败，本地也必须清干净
    }
    setToken(null);
    set({ member: null, consents: [], ai: null });
  },
}));
